module.exports = __webpack_public_path__ + "static/media/Pennsbury_Manor_Museum_Morrisville_PA_diorama_background_in_progress_1.592c61ab.webp";